import styled from 'styled-components';

import colors from '../../styles/colors';

// eslint-disable-next-line import/prefer-default-export
export const Pill = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  margin-top: 4px;
  padding: 3px 10px;
  border: none;
  border-radius: 12px;
  background: ${colors.shades.secondary5};
  color: ${colors.shades.secondary1};
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;

  &:hover {
    background: ${colors.shades.secondary7};
  }
`;
